import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-country-selector-section',
  templateUrl: './country-selector-section.component.html',
  styleUrls: ['./country-selector-section.component.scss']
})
export class CountrySelectorSectionComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
  }

}
